import { motion } from "framer-motion";
import { ShieldCheck, FileCheck2, Lock, Stamp } from "lucide-react";
import { COMPLIANCE } from "@/lib/site-data";

const ICONS = [ShieldCheck, FileCheck2, Lock, Stamp];

export default function Trust() {
  return (
    <section id="compliance" data-testid="trust-section" className="relative bg-ab-bg py-24 md:py-32">
      <div className="ab-container">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-7">
            <p className="ab-eyebrow text-ab-accent">Trust by design</p>
            <h2 className="ab-h2 text-5xl md:text-6xl mt-4 max-w-3xl">
              Built for the regulators. <span className="italic font-light">Loved</span> by IT.
            </h2>
          </div>
          <p className="lg:col-span-5 text-ab-muted leading-relaxed">
            PranaOs ships ABDM rails, CERT-IN-audited security, granular consent and audit trails — so your CIO can sleep, and your CFO can scale.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {COMPLIANCE.map((c, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                key={c.name}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.06 }}
                data-testid={`compliance-${i}`}
                className="ab-card p-7 group"
              >
                <div className="flex items-center justify-between">
                  <span className="w-11 h-11 rounded-full bg-ab-bg flex items-center justify-center text-ab-primary group-hover:bg-ab-primary group-hover:text-white transition">
                    <Icon className="w-5 h-5" />
                  </span>
                  <span className="font-mono-tech text-xs text-ab-muted">0{i + 1}</span>
                </div>
                <h3 className="mt-6 font-serif text-2xl text-ab-primary">{c.name}</h3>
                <p className="mt-2 text-sm text-ab-muted leading-relaxed">{c.note}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
